'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_ImageEditor$Props(images, onDeleteImage, onAddImage, onUploadRequested) {
  this.LJ = null;
  this.Sx = null;
  this.Sw = null;
  this.Sy = null;
  this.LJ = images;
  this.Sx = onDeleteImage;
  this.Sw = onAddImage;
  this.Sy = onUploadRequested;
}
export { $c_Lmealorama_components_ImageEditor$Props as $c_Lmealorama_components_ImageEditor$Props };
$p = $c_Lmealorama_components_ImageEditor$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_ImageEditor$Props;
/** @constructor */
function $h_Lmealorama_components_ImageEditor$Props() {
}
export { $h_Lmealorama_components_ImageEditor$Props as $h_Lmealorama_components_ImageEditor$Props };
$h_Lmealorama_components_ImageEditor$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_ImageEditor$Props)) {
    var x = this.LJ;
    var x$2 = x$0.LJ;
    if (((((x === null) ? (x$2 === null) : x.f(x$2)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.Sx, x$0.Sx)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.Sw, x$0.Sw))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.Sy, x$0.Sy);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.LJ;
      break;
    }
    case 1: {
      return this.Sx;
      break;
    }
    case 2: {
      return this.Sw;
      break;
    }
    case 3: {
      return this.Sy;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_ImageEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k6)));
}
export { $isArrayOf_Lmealorama_components_ImageEditor$Props as $isArrayOf_Lmealorama_components_ImageEditor$Props };
var $d_Lmealorama_components_ImageEditor$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_ImageEditor$Props, "mealorama.components.ImageEditor$Props", ({
  k6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_ImageEditor$Props as $d_Lmealorama_components_ImageEditor$Props };
//# sourceMappingURL=mealorama.components.-Image-Editor$-Props.js.map
